import { render, staticRenderFns } from "./abs_summaries.vue?vue&type=template&id=07a06e40&scoped=true&"
import script from "./abs_summaries.vue?vue&type=script&lang=js&"
export * from "./abs_summaries.vue?vue&type=script&lang=js&"
import style0 from "./abs_summaries.vue?vue&type=style&index=0&id=07a06e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a06e40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
